// Socket events missed during suspension are not replayed. Fetch the open
// account conversation once on resume/reconnect, independently of list sync.
export function createActiveChatCatchup({ getAuthState, getChatState, getActiveRouteId, fetchConversation }) {
  const pending = new Map();
  let generation = 0;
  const userId = auth => String(auth?.user?.id || auth?.user?._id || '');
  const busy = chat => !chat || chat.hasMacProject || chat.isInferencing || chat.isInferencingWaiting
    || chat.messages?.some(message => message.isPending || message.isStreaming || message.isTyping || message.isWaiting || message.isThinking);

  return {
    invalidate() { generation += 1; pending.clear(); },
    catchup() {
      const id = String(getActiveRouteId() || '');
      const auth = getAuthState();
      if (!id || !auth?.token || !userId(auth) || auth._isSigningOut) return Promise.resolve();
      const chat = getChatState().chats?.find(item => String(item.id) === id);
      if (busy(chat)) return Promise.resolve();
      const session = auth._sessionGeneration;
      const owner = userId(auth);
      const token = auth.token;
      const key = JSON.stringify([id, owner, session, token, generation]);
      if (pending.has(key)) return pending.get(key);
      const started = generation;
      const messages = chat.messages;
      const request = Promise.resolve().then(() => fetchConversation(id)).then(fresh => {
        const currentAuth = getAuthState();
        if (started !== generation || getActiveRouteId() !== id || currentAuth?._isSigningOut
          || userId(currentAuth) !== owner || currentAuth?.token !== token
          || currentAuth?._sessionGeneration !== session) return;
        const store = getChatState();
        const current = store.chats?.find(item => String(item.id) === id);
        if (busy(current) || current.messages !== messages) return;
        const responseOwner = fresh?.user?.id || fresh?.user?._id || fresh?.user;
        if (String(fresh?.id || fresh?._id || '') !== id || String(responseOwner || '') !== owner) return;
        // Detail can contain fewer rows than locally loaded archived history.
        // The store merges by message id and retains those older pages.
        store.addChats([fresh]);
      }).catch(() => {
        // Reconnect and foreground are best-effort; the next event can retry.
      }).finally(() => {
        if (pending.get(key) === request) pending.delete(key);
      });
      pending.set(key, request);
      return request;
    },
  };
}
